import {
  TripWrite,
} from 'src/common/external/bambi-api/bambiApi';
import {
  TripsBulkCreateWrite,
} from 'src/common/external/bambi-api/tripsApi';

import { AddTripFormValues } from '../FormValues';
import { buildNewTripPayload } from './adaptFormValuesHelpers';

export function adaptFormValuesToTripsBulkCreate(
  formValues: AddTripFormValues
): TripsBulkCreateWrite {
  return {
    trips: formValues.trips.map(
      (trip): TripWrite => buildNewTripPayload(trip, formValues)
    ),
  };
}
